<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="prod_id_choice" [ttModel]="edit.prod_id_choice" ttReadonly></tt-input>
        <tt-input ttLabel="prod_name_choice" [ttModel]="edit.prod_name_choice" ttReadonly></tt-input>
        <tt-select ttLabel="prod_id_choosed" [(ttModel)]="edit.prod_id_choosed" [ttData]="selectListRelatedChoices" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-textarea ttLabel="choicenote" [(ttModel)]="edit.choicenote"></tt-textarea>
        <tt-button-save ttText="orderheadchoice_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
